import React, { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { KoTabs, KoLoader, KoText, KoTitle } from 'packages';
import TimeSheetApproval from '../timesheet';

import {  useParams } from 'react-router';
import {InboxAPI} from '../inbox.service';
import LeaveApproval from '../leave';
import { useSelector } from 'react-redux';
import styles from './inbox.module.scss';
// import ExpensesApprove from '../expenses';
dayjs.extend(customParseFormat);

const InboxComponent = () => {
  const [loading, setLoading] = useState(true);
  const [userTotalHours, setUserTotalHours] = useState([]);
  const {approvalId} = useParams();
  const apprCount = useSelector(state => state?.approvalCount);

  useEffect(() => {
    setLoading(false);
   
  }, [approvalId]);

  let tabs = [
    {
      label: <div className={styles.tabs}>
        <KoText text={`Timesheets`} />
        {apprCount?.data?.timesheetCount > 0 &&  <KoText className={styles.badge} text={`${apprCount?.data?.timesheetCount ? apprCount?.data?.timesheetCount : '0'}`} />}
      </div>,
      key: 'tms',
      children: <TimeSheetApproval />
    },
    {
      label: <div className={styles.tabs}>
        <KoText text={`Leave`} />
        {apprCount?.data?.leaveCount > 0 && <KoText className={styles.badge} text={`${apprCount?.data?.leaveCount ? apprCount?.data?.leaveCount : '0'}`} />}
      </div>,
      key: 'act',
      children: <LeaveApproval />
    }
    // {
    //   label: <div className={styles.tabs}>
    //     <KoText text={`Expense`} />
    //     {apprCount?.data?.leaveCount > 0 && <KoText className={styles.badge} text={`${apprCount?.data?.leaveCount ? apprCount?.data?.leaveCount : '0'}`} />}
    //   </div>,
    //   key: 'expense',
    //   children: <ExpensesApprove />
    // }
  ];

  useEffect(() => {
    fetchUserTotalHours();
     
  }, []);

  const fetchUserTotalHours = (userId) => {
    setLoading(true);
    InboxAPI.getUserTotalHours(userId).then(
      (data) => {
        setUserTotalHours(data?.worklogs || []);
        setLoading(false);
      },
      () => setLoading(false)
    );
  };



  const convertMinutesToHHMM =(minutes)=>{
    let hours = Math.floor(minutes / 60);
    let remainingMinutes = minutes % 60;
    return `${hours}.${remainingMinutes < 10 ? '0' : ''}${remainingMinutes}`;
  };

  const billableMinutes    = [];
  const nonBillableMinutes = [];
  const getLabel           = [];
  const totalHours         = [];

  if(userTotalHours && userTotalHours.length > 0){
    userTotalHours.forEach(entry => {
      billableMinutes.push(convertMinutesToHHMM(entry.totalBillableMinutes));
      nonBillableMinutes.push(convertMinutesToHHMM(entry.totalNonBillableMinutes));
      getLabel.push(entry.profile.email);
      totalHours.push(convertMinutesToHHMM(entry.totalMinutes));
    });
  }

  console.log('userTotalHours', apprCount);

  return (
    <div className={`profileSection approval badge ${styles.wrapperTabs}`}>
      <KoTitle text="Inbox" level={3} className={styles.title} />
      {loading && <KoLoader />}
      <KoTabs  options={tabs} />
    </div>
  );
};
export default InboxComponent;